import { Alert, Button } from "antd";
import styled from "styled-components";

// Shared by BinItem/BinContainer below and the Colour Palette trigger width,
// which is deliberately sized to 2/3 of the 3 bin fields combined — keep
// these in sync rather than duplicating the numbers in the calc().
const BIN_ITEM_WIDTH = 90;
const BIN_ITEM_GAP = 5;

export const IpdbOptionItem = styled.div<{ isGeoButtonVisible?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .ant-select {
    width: 280px;
  }

  .ipdb-option-zone-label {
    margin-top: ${(props) => (props.isGeoButtonVisible ? "24px" : "unset")};
  }

  .ipdb-option-bin-label {
    margin-top: 20px;
  }

  // targets BaseMenu's trigger-container
  // width matches 2/3 of the 3 bin fields combined
  &.ipdb-color-palette-selector .trigger-container {
    flex-grow: 0;
    width: calc((${BIN_ITEM_WIDTH}px * 3 + ${BIN_ITEM_GAP}px * 2) * 2 / 3);
    min-width: 0;
  }
`;

export const SectionLabelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--color-text-40);
  font-size: 12px;
  margin: 8px 8px 4px;
  line-height: 1.2;
`;

export const ZoneInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  .ant-btn {
    padding: 0;
    height: 24px;
    font-size: 1.2rem;
    display: flex;
    align-items: center;

    .ant-spin {
      width: 25px;
    }
  }

  .ant-select-multiple.ant-select-allow-clear .ant-select-selector {
    padding-right: 4px;
  }

  .ant-tree-select .ant-select-clear {
    right: -21px;
    top: calc(50% - 10px);
    padding-left: 6px;
    width: calc(15px + 6px) !important;
    height: 32px !important;
    display: flex;
    background: transparent;
  }
`;

export const BinContainer = styled.div`
  display: flex;
  gap: ${BIN_ITEM_GAP}px;
  flex-direction: row;
`;

export const BinInputLabel = styled.span`
  font-size: 1.2rem;
  color: #9b9b9b;
`;

export const BinItem = styled.div`
  max-width: ${BIN_ITEM_WIDTH}px;
  display: flex;
  flex-direction: column;
`;

export const BinResetButton = styled(Button)`
  display: flex;
  align-items: center;
  height: 32px;
  color: #a2aaad;
  padding: 0;
  margin-top: auto;

  &:hover {
    color: var(--color-primary);
  }
`;

export const SwitcherIcon = styled.span`
  transform: translateY(2px);
  color: rgba(var(--color-text-rgb), 0.3);
  transition: 0.3s ease;

  &:hover {
    color: var(--color-primary);
  }
`;

export const LoadingContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
`;

export const LayerTitleContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const LayerActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 8px;
`;

export const LayerEditIcon = styled.div<{ $disabled?: boolean }>`
  cursor: pointer;
  display: flex;

  svg {
    color: var(--color-icon);

    &:hover {
      color: ${({ $disabled }) =>
        $disabled ? "var(--color-icon)" : "var(--color-primary)"};
    }
  }
`;

export const StyledAlert = styled(Alert)`
  margin: 0 16px;
  line-height: 1.2;

  .ant-alert-message {
    color: var(--ant-error-color);
  }
`;
